import * as React from 'react';

import { trackFunnel } from '../../funnel/tracking';

// Homepage promo (~85s, silent-first: every VO line is on screen). Source
// lives in video/ (Remotion); regenerate with `cd video && npm run render`.
// Click-to-play only — no autoplay, no third-party embed. See
// PROMO_VIDEO_PLAN.md. Styled by .dp-video in homepage.css since the page
// dropped MUI for the data-product design.
export default function PromoVideo() {
  const trackedRef = React.useRef(false);

  const handlePlay = () => {
    if (trackedRef.current) return;
    trackedRef.current = true;
    trackFunnel('promo_video_played');
  };

  return (
    <section className="dp-video" id="video">
      <div className="dp-shell">
        <video
          controls
          playsInline
          preload="metadata"
          poster="/promo-poster.png"
          src="/promo.mp4"
          onPlay={handlePlay}
        />
      </div>
    </section>
  );
}
